<template>
  <div>
    <multiselect
    class="tags-picker"
    v-model="selected"
    track-by="id"
    @open="isDropdownOpened = true"
    @close="isDropdownOpened = false"
    @search-change="asyncFind"
    @input="onChanged"
    :placeholder="placeholder"
    :multiple="true"
    :searchable="true"
    :loading="isLoading"
    :internal-search="false"
    :close-on-select="false"
    :open-direction="position"
    :max-height="maxHeight"
    :disabled="disabled"
    :options="usersList">
      <span slot="noResult">Никого не найдено</span>
      <template slot="option" slot-scope="props">
        <span class="dropdown-option">
          <span
            class="option-tagged"
            v-for="specializationId in props.option.specializationsIds"
            :style="{'background-color': allSpecializationsKeyed[specializationId + ''].color, 'color': getTextColor(allSpecializationsKeyed[specializationId + ''].color)}"
            :key="specializationId + '' + props.option.id">
            {{ allSpecializationsKeyed[specializationId + ''].name }}
          </span>

          <span v-if="props.option.status == -1">(деактивирован)</span>
          {{ props.option.fullName() }}</span>
      </template>
      <template slot="tag" slot-scope="{ option, remove }">
        <span class="tagged" v-bind:style="{'background-color': userBaseSpecialization(option).color, 'color': getTextColor(userBaseSpecialization(option).color)}">
          <span>{{ userBaseSpecialization(option).name }} - {{ option.fullName() }}</span>
          <span class="remove-tag" @click="remove(option)">
            <i class="fal fa-times"></i>
          </span>
        </span>
      </template>
    </multiselect>
      <div class="transparent-overlay" v-if="isDropdownOpened" @click.prevent.stop></div>
  </div>
</template>

<style scoped>
.tags-picler {
  z-index: 2;
}
.transparent-overlay {
  position: fixed;
  z-index: 1;
  top: -300%;
  left: -300%;
  width: 600%;
  height: 600%;
  background-color: transparent;
}
</style>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { mapGetters } from "vuex"
import { USERS_REQUEST } from "@/store/actions/users"

import textColor from '@/utils/textColor'
//import User from '@/models/user';
//import apiCall from "@/utils/api";

export default {
  name: 'UsersPicker',
  components: { Multiselect },
  props: {
    'value': {
      type: Array,
    },
    'disabled': {
      type: Boolean,
      default: false
    },
    'multiple': {
      type: Boolean,
      default: true
    },
    'placeholder': {
      type: String,
      default: "Выберите пользователей"
    },
    'includeDeactivated': {
      type: Boolean,
      default: false
    },
    'allCustomers': {
      type: Boolean,
      default: false
    },
    'roles': {
			type: Array,
			default: () => []
		},
    'hiddenRoles': {
			type: Array,
			default: () => []
		},
    'ids': {
      type: Array,
      default: () => []
    },
    'position': {
      type: String,
      default: ''
    },
    'maxHeight': {
      type: Number,
      default: 300
    }
  },
  data () {
    return {
      isLoading: false,
      isDropdownOpened: false,
      selected: null,
      query: '',
      users: []
    }
  },
  computed: {
    ...mapGetters(["allUsers", "activeProject", "customerRoles", "allSpecializationsKeyed"]),
    usersList() {
      let list = this.users
      if (!this.includeDeactivated) {
        list = list.filter(u => u.status != -1)
      }
      if (this.activeProject) {
        list = list.filter(u => this.allCustomers || !this.customerRoles.includes(u.roleId) || this.activeProject.customerIds.indexOf(u.id) !== -1)
      }
      if (this.roles && this.roles.length) {
        list = list.filter(u => this.roles.includes(u.roleId))
      }
      if (this.hiddenRoles && this.hiddenRoles.length) {
        list = list.filter(u => this.hiddenRoles.indexOf(u.roleId) === -1)
      }
      if (this.ids && this.ids.length) {
        list = list.filter(u => this.ids.indexOf(u.id) !== -1)
      }
      if (this.query.length) {
        list = list.filter(u => {
          return u.firstName.toLowerCase().indexOf(this.query) !== -1 || 
                u.lastName.toLowerCase().indexOf(this.query) !== -1 ||
                u.middleName.toLowerCase().indexOf(this.query) !== -1
        })
      }
      return list
    }
  },
  watch: {
    allUsers(newVal) {
      this.users = newVal
      if (this.value) {
        this.selected = this.users.filter(p => this.value.indexOf(p.id) !== -1)
      }
      this.isLoading = false
    },
    value() {
      if (this.value) {
        this.selected = this.users.filter(p => this.value.indexOf(p.id) !== -1)
      }
    }
  },
  mounted() {
    this.isLoading = true
    this.$store.dispatch(USERS_REQUEST)
  },
  methods: {
    asyncFind (query) {
      this.query = query.toLowerCase()
      // this.isLoading = true
      /*apiCall({ url: "users?query=" + query, method: "GET" })
      .then(resp => {
        this.updateUsers(resp)
        this.isLoading = false
      })*/
      
      this.isLoading = false
    },
    onChanged(values) {
      if (!this.multiple) {
        this.$emit('input', values.length > 0 ? values[values.length-1].id : null)
      } else {
        this.$emit('input', values.map(p => p.id))
      }
    },
    userBaseSpecialization(user) {
      if (user.specializationsIds.length === 0) {
        return null
      }
      return this.allSpecializationsKeyed[user.specializationsIds[0] + ''] ?? {}
    },
    getTextColor(color) {
      return textColor(color)
    }
  }
}
</script>